<template>
  <div>
        <div class="painel">
        <img src="/revisorPisCofins/img/Logo.svg" alt="">
        </div> 
      <div class="bgbloco">
          <div class="foraCaixa">
            <div>
                <img src="/revisorPisCofins/img/Computador.svg" alt="">
                <div class="letras">
                    <p style="font-weight:bold;">
                O REVISOR PIS/COFINS tem como objetivo rastrear nos Documentos Fiscais que foram emitidos pela pessoa jurídica, as situações de tributação Pis/Cofins sobre Produtos Monofásicos, Produtos Sujeitos à Alíquota Zero e Produtos Sujeitos à Substituição Tributária, que não estão de acordo com a legislação tributária.
                <br>
                <button class="btnRed" style="width:115px;height:37px;margin-top:30px;" @click="$router.push({name:'op',params:{id:1,isConsulta:'revisar'}})" v-show="userNot"> Acessar </button>
                    </p>           
                </div>  
            </div> 
            <div style="margin-top:30px;font-weight: bold;">
               <a target="_blank" href="https://www.lefisc.com.br/ncm/tributacaoMono.html" style="text-align:justify;">Simples Nacional: Vide anexo</a>

               </div>
<ul>

    <li style="color:#6A6A6A;font-weight: bold;">a) Alíquota Zero: Conforme previsto na LC nº 123, de 2006, art. 18, §4º-A, desde 01 de janeiro de 2009, a tributação monofásica se aplica ao Simples Nacional.</li>
    <li style="color:#6A6A6A;font-weight: bold;">b) Tributado Integralmente: Posicionamento adotado pela RFB.</li> 
</ul>
            <div style="margin-top:30px;">
               <p style="text-align:justify;">Esta ferramenta deverá ser utilizada para o cálculo de Pis/Pasep e Cofins corrente e de períodos anteriores, da pessoa jurídica Varejista (não fabricante e não importadora).</p><div>
As operações com Produtos Monofásicos abrangidas pelo Revisor são relativas as seguintes legislações:</div>
<ul>

    <li style="color:#6A6A6A">Combustíveis: Lei 9.718 de 1998, art. 4º a 6º.</li>
    <li >Medicamentos: Lei 10.147 de 2000. </li>
    <li style="color:#6A6A6A">Veículos e Autopeças: Lei 10.485 de 2002.</li>
</ul>
 

<div style="text-align:justify;">As operações com Produtos Sujeitos à Alíquota Zero abrangidas pelo Revisor são relativas as seguintes legislações:</div>
<ul>
    <li style="color:#6A6A6A">Lei 10.865 de 2004, art. 28;</li>
    <li style="color:#6A6A6A">  Lei 10.925 de 2004, art. 1º;</li>
    <li style="color:#6A6A6A">Lei 13.097 de 2015, art. 28.</li>
</ul>	 

<div>As operações com Produtos Sujeitos à Substituição Tributária abrangidas pelo Revisor são relativas as seguintes legislações:</div>
<ul>
    <li style="color:#6A6A6A">Lei 9.715 de 1998, art. 5º; Lei Complementar 70 de 1991, art. 3º. </li>
    <li style="color:#6A6A6A">MP 2158-35/2001, art. 43.</li>
</ul>
<p style="text-align:justify;">
Simples Nacional A ME ou EPP optante pelo Simples Nacional que proceda à comercialização de produtos sujeitos à substituição tributária ou tributação monofásica da contribuição para o PIS/Pasep e da Cofins deve segregar a receita decorrente da venda desse produto indicando a existência de substituição tributária/tributação monofásica para as referidas contribuições, de forma que serão desconsiderados, no cálculo do Simples Nacional, os percentuais a elas correspondentes.
</p>
<div>
    <p style="text-align:justify;">
Como regra geral não se aplica à alíquota zero em relação aos optantes pelo Simples Nacional, no entanto, há uma exceção em relação à comercialização de bebidas frias por varejista optante pelo Simples Nacional, que vai revender com alíquota zero também.
A legislação aplicável em relação à aplicação da tributação monofásica de PIS e COFINS ao Simples Nacional, é Lei Complementar nº 123/2006, art. 18 e também a Resolução CGSN nº 140, de 2018, art. 25, §6º. Para as bebidas frias, a revenda por varejista optante pelo Simples Nacional com alíquota zero, está na Lei nº 13.097/2015, art. 28, § 2º.</p>
No caso das bebidas frias no Simples Nacional informar a receita como tributação monofásica (aplicada até 30/04/2015, no entanto o PGDAS-D não foi alterado incluindo a alíquota zero, pois é somente nesta situação que se aplica ao Simples Nacional).
</div>
   
            </div>
          </div>  
        
      </div>
  
  
  </div>
</template>

<script>
export default {     
    data(){
        return{
            userNot:true
        }
    } ,
    mounted(){
        let json = localStorage.getItem('objCli')
        let a = JSON.parse(json)
        if(a.login == "lefisc"){
            this.userNot = false
        }
    }
}
</script>

<style>
.btnRed{
    background:#AF3437;
    border-radius: 5px;
    color:#fff;
    font-weight: bold;
    border:none;
}
a{
    text-decoration: none !important;
    color: #4A154B;
}
.bgbloco{
    background: #F3D8D9;
    text-align: justify;
}
.bgbloco .letras{
    max-width: 700px;
    text-align: justify;
    position: relative;   
}
.foraCaixa div:nth-child(1){
display: flex;
    align-items: center;
    justify-content: space-evenly;
}
.foraCaixa{
    background: #fff;
     padding: 30px 40px;
    max-width: 1130px;
    position: relative;
top:-60px;
    width: 100%;
    margin:0 auto;
    border-radius: 5px;
    color:#6A6A6A;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
}
@media screen and (max-width: 600px) { 
  .bgbloco{  
    justify-content: center;
    flex-direction: column;
}
.bgbloco img{
    width: 170px;
}
}
</style>